import axios from 'axios'

const isNewVersion = () => {
    let url = `//${window.location.host}/MCD-SRM/static/config.json?t=${new Date().getTime()}`;
    console.log("🚀 ~ file: systemUpdate.js:6 ~ isNewVersion ~ url", url)
    axios.get(url, {
        headers: {
            'x-access-token': localStorage.getItem('token')
        }
    }).then(res => {
        console.log("🚀 ~ file: systemUpdate.js:6 ~ axios.get ~ res", res)
        if (res.status === 200) {
            let vueVersion = res.data.version;
            let localVueVersion = window.localStorage.getItem("vueVersion");

            if (localVueVersion && localVueVersion != vueVersion) {
                window.localStorage.setItem('vueVersion', vueVersion);
                window.sessionStorage.setItem('vueVersion', vueVersion)
                window.location.reload();
                return;
            } else {
                window.localStorage.setItem('vueVersion', vueVersion);
                window.sessionStorage.setItem('vueVersion', vueVersion)
            }
        }
    });
}

export default {
    isNewVersion
}